export const TRANSFER_GET = 'TRANSFER_GET';
export const TRANSFER_CLEAR = 'TRANSFER_CLEAR';
export const TRANSFER_LIST = 'TRANSFER_LIST';
export const TRANSFER_LIST_CLEAR = 'TRANSFER_LIST_CLEAR';
